import {TOKENS} from "../../constants/tokens";
import {checkIfOwner} from "./checkIfOwner";
import {checkIfHexBlockedByEnemyUnit} from "./checkIfHexBlockedByEnemyUnit";

export const checkIfOnWorkingBarracks = (unitHexKey, hexes, specialBuildings, player, citiesCache, units, buildingsDamage) => {
  return hexes[unitHexKey] === TOKENS.BARRACKS
    && checkIfOwner(unitHexKey, player.color, citiesCache)
    && !checkIfHexBlockedByEnemyUnit(unitHexKey, TOKENS.BARRACKS, player.id, units, hexes, specialBuildings, buildingsDamage);
}